import React from 'react';
import { useTranslation } from 'react-i18next';
import GoodsParamSelect from './GoodsParamSelect';

export function ParamHelp({ title }) {
  if (!title) return null;
  return (
    <span className="wf-editor-fission__help" title={title} aria-label={title}>
      ?
    </span>
  );
}

export function ParamRow({ label, hint, children, stacked = false }) {
  return (
    <div className={`wf-editor-fission__row${stacked ? ' wf-editor-fission__row--stack' : ''}`}>
      <div className="wf-editor-fission__label">
        <span>{label}</span>
        <ParamHelp title={hint} />
      </div>
      <div className="wf-editor-fission__control">{children}</div>
    </div>
  );
}

export function ParamTextarea({
  label,
  hint,
  value,
  placeholder,
  maxLength,
  rows = 4,
  disabled,
  onChange,
}) {
  return (
    <ParamRow label={label} hint={hint} stacked>
      <textarea
        className="wf-editor-fission__textarea"
        rows={rows}
        value={value}
        maxLength={maxLength}
        disabled={disabled}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
    </ParamRow>
  );
}

export function InlineRadio({ name, value, checked, disabled, onChange, children }) {
  return (
    <label className="wf-editor-fission__radio">
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <span className="wf-editor-fission__radio-mark" aria-hidden />
      <span>{children}</span>
    </label>
  );
}

export function ParamSelect({ label, hint, value, options, disabled, onChange, ariaLabel }) {
  return (
    <ParamRow label={label} hint={hint}>
      <GoodsParamSelect
        className="wf-editor-fission__select"
        variant="default"
        value={value}
        options={options}
        disabled={disabled}
        ariaLabel={ariaLabel || label}
        onChange={onChange}
      />
    </ParamRow>
  );
}

export function GenerateCountRow({ value, disabled, onChange, max = 4 }) {
  const { t } = useTranslation('workbench');
  const options = [1, 2, 3, 4].filter((n) => n <= max);
  return (
    <ParamRow label={t('workflowParamFields.generateCount')} hint={t('workflowParamFields.generateCountHint')}>
      {options.map((n) => (
        <InlineRadio
          key={n}
          name="wf-generate-count"
          value={String(n)}
          checked={Number(value) === n}
          disabled={disabled}
          onChange={() => onChange(n)}
        >
          {n}
        </InlineRadio>
      ))}
    </ParamRow>
  );
}
